import { render, staticRenderFns } from "./MyProfilePasswordTab.vue?vue&type=template&id=662b384b&scoped=true&"
import script from "./MyProfilePasswordTab.vue?vue&type=script&lang=js&"
export * from "./MyProfilePasswordTab.vue?vue&type=script&lang=js&"
import style0 from "./MyProfilePasswordTab.vue?vue&type=style&index=0&id=662b384b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b384b",
  null
  
)

export default component.exports